import { Box, BoxProps } from '@mui/material';
import jsonExport from 'jsonexport/dist';
import { Fragment, memo } from 'react';
import { BooleanField, BulkDeleteButton, BulkDeleteButtonProps, BulkExportButton, BulkExportButtonProps, Datagrid, DateField, downloadCSV, EditButton, List, ReferenceField, ShowButton, ShowView, SimpleShowLayout, TextField, TextInput } from 'react-admin';
import ContextShowButton from '../../Components/ContextShowButton';

const DevicesListActionToolbar = (props: BoxProps) => <Box sx={{ alignItems: 'center', display: 'flex' }}>{props.children}</Box>;
const DevicesListBulkActions = memo((props: BulkDeleteButtonProps & BulkExportButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
    <BulkExportButton {...props} />
  </Fragment>
));
const exporter = (users: any[]) => {
  return jsonExport(users, (err: Error, csv: string) => downloadCSV(csv, 'users'));
};
const rowClick = (id: unknown, resource: unknown, record: any) => {
  if (record.commentable) {
    return 'edit';
  }
  return 'show';
};
const DevicesPanel = () => {
  return (
    <ShowView>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="token" />
        <TextField source="phoneNumber" />
        <TextField source="encryptedVerificationToken" />
        <TextField source="vendor" />
        <TextField source="model" />
        <TextField source="verificationSms" />
        <TextField source="user" />
        <TextField source="firebaseToken" />
        <DateField source="migratedAt" sortByOrder="DESC" />
        <BooleanField source="phoneNumberValid" />
        <TextField source="originalPhoneNumber" />
        <TextField source="appVersion" />
        <DateField source="createdAt" sortByOrder="DESC" />
        <DateField source="updatedAt" sortByOrder="DESC" />
      </SimpleShowLayout>
    </ShowView>
  );
};

//const usersFilter = [<SearchInput source="fullName" alwaysOn />, <TextInput source="company" defaultValue="" />, <TextInput source="id" defaultValue="" />, <TextInput source="uuid" defaultValue="" />];
const usersFilter = [
  <TextInput label="Phone Number" source="phoneNumber" alwaysOn />,
  <TextInput label="User ID" source="user" defaultValue="" alwaysOn />,
  <TextInput label="Device ID" source="id" defaultValue="" alwaysOn />,
  <TextInput source="appVersion" defaultValue="" alwaysOn />
];

const DevicesList: React.FC = () => {
  return (
    <List filters={usersFilter} sort={{ field: 'id', order: 'DESC' }} exporter={exporter}>
      <Datagrid bulkActionButtons={<DevicesListBulkActions />} rowClick={rowClick} expand={DevicesPanel} optimized sx={{ image: { maxHeight: '1rem' } }}>
        <TextField source="id" />
        <TextField source="token" />
        <TextField source="phoneNumber" />
        <TextField source="vendor" />
        <TextField source="model" />
        <ReferenceField label="User" source="user" reference="users">
          <ContextShowButton resource="users" label="fullName" />
        </ReferenceField>
        <BooleanField source="phoneNumberValid" />
        <TextField source="appVersion" />
        <DateField source="createdAt" sortByOrder="DESC" />
        <DateField source="updatedAt" sortByOrder="DESC" />
        <DevicesListActionToolbar>
          <EditButton />
          <ShowButton />
        </DevicesListActionToolbar>
      </Datagrid>
    </List>
  );
};

export default DevicesList;
